const shop = () => import('@/views/main/shop/shop.vue')
export default {
  path: '/main/shop',
  name: 'shop',
  component: shop,
  children: []
}
